import firebase from "firebase/app";
import "firebase/auth";

export default async () => {
    return await firebase
        .auth()
        .currentUser.getIdToken()
        .then(token => token);
};
